import React, { useContext } from 'react';
import { PapiDeviation, PapiSellerDiscount } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TierProductCardDumbDesktop from './TierProductCardDumbDesktop';
import TierProductCardDumbMobile from './TierProductCardDumbMobile';

export interface Props {
  coverImage?: PapiDeviation;
  showMatureCover?: boolean;
  stats?: {
    subscribers?: number;
    deviations?: number;
    posts?: number;
  };
  title?: string;
  description?: string;
  price?: string;
  discount?: PapiSellerDiscount;
  allDiscounts?: PapiSellerDiscount[];
  benefits?: string[];
  hasDiscord?: boolean;
  info?: string;
  dataHook?: string;
  tierState?: string;
  ctaButton?: React.ReactNode;
  ctaWrapperClassName?: string;
  secondaryCtaButton?: React.ReactNode;
  withExpandButton?: boolean;
  isHighlighted?: boolean;
  showEmptyPlaceholders?: boolean;
  className?: string;
  isCollapsed?: boolean;
  innerRef?: (node: HTMLElement | null) => void;
  coverAreaExtrasLeft?: React.ReactNode;
  coverAreaExtrasRight?: React.ReactNode;
  onToggleCollapsed?: (isCollapsed: boolean) => void;
  onClick?: () => void;
}

const TierProductCardDumb: React.FC<Props> = props => {
  const isMobile = useContext(MobileContext);
  return isMobile ? (
    <TierProductCardDumbMobile {...props} />
  ) : (
    <TierProductCardDumbDesktop {...props} />
  );
};
TierProductCardDumb.displayName = 'TierProductCardDumb';

export default TierProductCardDumb;
